export function Ratio21x9Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="18.75" y="6.875" width="6.25" height="17.5" rx="2" transform="rotate(90 18.75 6.875)" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio21x9Icon.displayName = 'Ratio21x9Icon';
